// ENV:localhost/development/production

const env = "production";
const commonConfig = {
  webName: "sriland-payment-managment-system",
  address: "",
  mobile: "",
  email: "",
  whatsapp: "",
  devsSite: "",
  noImage: "no_image_available.jpg",
  maxBulkPaymentLimit: 5000000,
  batapolaThreshold: 500000,
  batapolaFlatFee: 25000,
  batapolaRate: 0.05,
};

const baseDomainLocal = "http://localhost/app/sriland-bankslip-management";

const baseDomainDev = window.location.hostname.includes("www")
  ? "https://www.devsriland.taprodevpos.com"
  : "https://devsriland.taprodevpos.com";

const baseDomainProd = window.location.hostname.includes("www")
  ? "https://www.srilanderp.taprodevpos.com"
  : "https://srilanderp.taprodevpos.com";

const environments: any = {
  localhost: {
    webLink: `${baseDomainLocal}`,
    server: `${baseDomainLocal}/server`,
    serverapi: `${baseDomainLocal}/server/Api`,
    imagepath: `${baseDomainLocal}/images`,
  },
  development: {
    webLink: `${baseDomainDev}`,
    server: `${baseDomainDev}/server`,
    serverapi: `${baseDomainDev}/server/Api`,
    imagepath: `${baseDomainDev}/images`,
  },
  production: {
    webLink: `${baseDomainProd}`,
    server: `${baseDomainProd}/server`,
    serverapi: `${baseDomainProd}/server/Api`,
    imagepath: `${baseDomainProd}/images`,
  },
};

const config = {
  ...commonConfig,
  ...environments[env],

  // Web routes
  login: "/",
  loginSuccess: "login-success",
  dashboard: "dashboard",
  vehicle_sale: "vehicle_sale",
  shop_sale: "shop_sale",
  payment_proccess: "payment_proccess",
  payment_history: "payment_history",
  manage_customers: "manage_customers",
  remittance: "remittance",
  report_by_customer: "report_by_customer",
  report_by_date: "report_by_date",
  report_by_inquery: "report_by_inquery",
  report_by_remittance: "report_by_remittance",
  system_logs: "system_logs",
  manage_users: "manage_users",
  manage_dealers: "manage_dealers",
  manage_vehicle: "manage_vehicle",
  vehicle_config: "vehicle_config",
  manage_stock_transfer: "manage_stock_transfer",
  dealer_monitor: "dealer_monitor",
  vehicle_history: "vehicle_history",
  stock_transfer_history: "stock_transfer_history",
  stock_reports: "stock_reports",
  financial_reports: "financial_reports",
  dpmc_remittance_report: "dpmc_remittance_report",
  sales_invoice_breakdown: "sales_invoice_breakdown",
  day_summary: "day_summary",
  manage_bank: "manage_bank",
  manage_tickets: "manage_tickets",
  triggered_emails: "triggered_emails",
  manage_sales_persons: "manage_sales_person",
  report_by_sales_person: "report_by_sales_person",
  manage_credit: "manage_credit",
  manage_grn: "manage_grn",
  returned_vehicle_report: "returned_vehicle_report",
  manage_products: "manage_products",
  offer_for_inquiry: "offer_for_inquiry",
  report_bike_threewheel: "report_bike_threewheel",
  custom_reports: "custom_reports",
  node_reports: "node_reports",
  ai_agent: "ai_agent",
  sub_dealer_cash_report: "sub_dealer_cash_report",


  //commons
  appLogo: "applogo.jpg",
  signInBg: "signInBg.jpeg",
};

export default config;
